import styled from 'styled-components'

export const Form = styled.form`
  margin-bottom: 3rem;
  display: flex;
  flex-direction: column;
`